import * as React from "react";
const ManagerDashboardViewContainer = React.lazy(() => import("./ManagerDashboardViewContainer"));

export { ManagerDashboardViewContainer as ManagerDashboardView };
